import React, { Component } from "react";

class Breadcrumb extends Component {
  render() {
    return (
      <React.Fragment>
        <div
          className="breadcrumb-area rn-bg-color ptb--25"
          style={{ backgroundColor: "#111a2a" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb-inner pt--50">
                  {/* <h2 className="title">{title}</h2> */}
                  {/* <ul className="page-list">
                    <li className="breadcrumb-item">
                      <Link to={`${process.env.PUBLIC_URL}`}>Anasayfa</Link>
                    </li>
                    {parent ? (
                      <li className="breadcrumb-item">{parent}</li>
                    ) : (
                      ""
                    )}
                    <li className="breadcrumb-item active">{title}</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Breadcrumb;
